import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-service/ClassifierService/DynamicFlatNodeService.ts";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.map.delete-all.js";
import "core-js/modules/esnext.map.every.js";
import "core-js/modules/esnext.map.filter.js";
import "core-js/modules/esnext.map.find.js";
import "core-js/modules/esnext.map.find-key.js";
import "core-js/modules/esnext.map.includes.js";
import "core-js/modules/esnext.map.key-of.js";
import "core-js/modules/esnext.map.map-keys.js";
import "core-js/modules/esnext.map.map-values.js";
import "core-js/modules/esnext.map.merge.js";
import "core-js/modules/esnext.map.reduce.js";
import "core-js/modules/esnext.map.some.js";
import "core-js/modules/esnext.map.update.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import { createEffect, forward } from 'effector';
import { pick } from 'ramda';
import { adapter } from "../adapters";
import { baseTypesMap } from "./BaseTypesMap";
export function createDynamicFlatNodeService( // eslint-disable-next-line @typescript-eslint/no-explicit-any
apiCall) {
  var update = createEffect({
    handler: function handler(_ref) {
      var items = _ref.items;
      var childrenMap = new Map();
      var nodesMap = {
        DynamicBaseGroupNode: [],
        DynamicGeneratedGroupNode: []
      };

      for (var i = 0; i < items.length; i++) {
        var flatItem = items[i];
        var key = buildKey({
          id: flatItem.parentId,
          type: flatItem.parentType
        });
        var node = adapter(flatItem);

        if (childrenMap.has(key)) {
          var arr = (childrenMap.get(key) || []).slice();
          arr.push(node);
          childrenMap.set(key, arr);
        } else {
          childrenMap.set(key, [node]);
        }
      }

      for (var _i = 0; _i < items.length; _i++) {
        var _childrenMap$get;

        var _flatItem = items[_i];

        var _node = adapter(_flatItem);

        var nodes = nodesMap[baseTypesMap[_node.type]].slice();

        var _key = buildKey({
          id: _flatItem.id,
          type: _flatItem.type
        });

        var children = (_childrenMap$get = childrenMap.get(_key)) === null || _childrenMap$get === void 0 ? void 0 : _childrenMap$get.map(pick(['id', 'type']));

        var populatedNode = _objectSpread(_objectSpread({}, _node), {}, {
          children: children || []
        }); // eslint-disable-next-line @typescript-eslint/no-explicit-any


        nodes.push(populatedNode) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ;
        nodesMap[baseTypesMap[_node.type]] = nodes;
      }

      return nodesMap;
    }
  }, {
    name: "update",
    sid: "os1r6b"
  });
  forward({
    ɔ: {
      from: apiCall.doneData,
      to: update
    },
    config: {
      sid: "v11hid"
    }
  });
  return {
    update: update
  };
}

function buildKey(params) {
  return "".concat(params.type, ":").concat(params.id);
}